// extracted by mini-css-extract-plugin
export default {"Landing":"Landing_Landing__raPfa","lander":"Landing_lander__6gD+A","PanelFix":"Landing_PanelFix__5L6mI"};